import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DocumentResponse } from 'src/app/jurisdiction/jurisdiction.domain';
import { ErrorService } from 'src/app/services/error/error.service';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-document-editor',
  templateUrl: './document-editor.component.html',
  styleUrls: ['./document-editor.component.scss'],
})
export class DocumentEditorComponent implements OnInit {
  @Input() label: string;
  @Input() required: boolean;
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() applicationId: string;
  @Input() documentId: number | string;
  @Input() documentType: string;
  @Input() isReadOnly: boolean;
  @Input() tooltip: string;

  @Output() update = new EventEmitter<any>();

  constructor(private fileService: FileService, private errorService: ErrorService) {}

  ngOnInit(): void {}

  get isRequired(): boolean {
    if (!this.form.get(this.controlName)?.validator) return false;

    if (this.form.get(this.controlName)?.validator && typeof this.form.get(this.controlName)?.validator === 'function') {
      const validator = this.form.get(this.controlName)?.validator({} as AbstractControl);
      return validator && validator.required;
    }

    return false;
  }

  onSelectFile(event: any, documentType: string, uploader: any, controlName: string) {
    if (this.form.get(controlName).value !== '') {
      this.fileService
        .updateSingleDocument(event.currentFiles[0], this.applicationId, this.documentId?.toString(), documentType, controlName)
        .subscribe(
          (response: any) => {
            uploader.clear();
            this.form.controls[controlName].setValue(event.currentFiles[0].name);
            this.errorService.throwErrorIfFailure(response, true);
            this.update.emit({ documentId: response.document[0].document_id, controlName: this.controlName });
          },
          error => {
            uploader.clear();
            this.errorService.throwErrorIfFailure(error, true);
          }
        );
    } else {
      this.fileService.uploadDocumentsForWorkflows(event, this.applicationId, documentType, controlName).subscribe(
        (response: DocumentResponse) => {
          uploader.clear();
          this.form.controls[controlName].setValue(event.currentFiles[0].name);
          this.errorService.throwErrorIfFailure(response, true);
          this.update.emit({ documentId: response.document[0].document_id, controlName: this.controlName });
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
          uploader.clear();
        }
      );
    }
  }

  downloadDocument(): void {
    this.fileService.readWorkflowDocument(this.documentId.toString()).subscribe((response: Blob) => {
      this.fileService.downloadDocument(response, this.form.controls[this.controlName]?.value);
    });
  }
}
